import { combineReducers } from 'redux';

import byId from './byId';
import allIds from './allIds';

export const getCommitments = (state) => state.byId;
export const getCommitment = (state, id) => state.byId[id];
export const getCommitmentIds = (state) => state.allIds;

export const getActiveCommitmentIds = (state) => (
  state.allIds.filter((id) => state.byId[id]._destroy !== 1)
);

export default combineReducers({
  byId,
  allIds,
});
